import React, { useState } from "react";
import { withRouter, Link, useParams } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { postResetPassword } from "../../helpers/fakebackend_helper";
import AuthShell from "./AuthShell";
import AuthField from "./AuthField";

const ResetPassword = () => {
  const { token } = useParams();
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { password: "", confirm: "" },
    validationSchema: Yup.object({
      password: Yup.string().min(8, "At least 8 characters").required("Required"),
      confirm: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords do not match")
        .required("Required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setError("");
      try {
        await postResetPassword(token, values.password);
        setDone(true);
      } catch (err) {
        setError(typeof err === "string" ? err : "Failed to reset password.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  document.title = "Reset Password | BiorGov Admin";

  return (
    <AuthShell title="Reset password" subtitle="Choose a new password for your account.">
      {done ? (
        <>
          <div className="alert alert-success">
            Your password has been reset. You can now sign in with the new password.
          </div>
          <div style={{ textAlign: "center", marginTop: "1.25rem" }}>
            <Link to="/login" style={{ color: "var(--bl-accent-light)" }}>Go to sign in →</Link>
          </div>
        </>
      ) : (
        <>
          {error && <div className="alert alert-danger" style={{ marginBottom: "1rem" }}>{error}</div>}
          <form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
            <AuthField
              label="New password"
              name="password"
              type="password"
              autoComplete="new-password"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.password}
              error={validation.errors.password}
              touched={validation.touched.password}
            />
            <AuthField
              label="Confirm password"
              name="confirm"
              type="password"
              autoComplete="new-password"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.confirm}
              error={validation.errors.confirm}
              touched={validation.touched.confirm}
            />
            <button type="submit" className="bl-btn-primary" style={{ width: "100%", padding: "0.7rem 1rem" }} disabled={validation.isSubmitting}>
              {validation.isSubmitting ? "Saving…" : "Reset password"}
            </button>
          </form>
        </>
      )}
    </AuthShell>
  );
};

export default withRouter(ResetPassword);
